import { getAnalytics } from 'firebase/analytics';
import { initializeApp } from 'firebase/app';

export const isProd =
  window.location.origin === 'https://r8trapp.com' ||
  window.location.origin === 'https://www.r8trapp.com';

const firebaseConfig = isProd
  ? {
      apiKey: 'AIzaSyDSON5PHjh4GGHAfAIC8ABPcmxGwophm4I',
      authDomain: 'r8tr-fe17e.firebaseapp.com',
      databaseURL: 'https://r8tr-fe17e.firebaseio.com',
      projectId: 'r8tr-fe17e',
      storageBucket: 'r8tr-fe17e.firebasestorage.app',
      messagingSenderId: '800501660029',
      appId: '1:800501660029:web:b328389f09564bf1793414',
      measurementId: 'G-S4P72PCNR1',
    }
  : {
      apiKey: 'AIzaSyA9KbWDo9M8kjHsj-OJTQHYLPjVc54wnlc',
      authDomain: 'r8tr-dev.firebaseapp.com',
      projectId: 'r8tr-dev',
      storageBucket: 'r8tr-dev.firebasestorage.app',
      messagingSenderId: '607817111155',
      appId: '1:607817111155:web:21584133214c9e7da1bc06',
      measurementId: 'G-6HWMCQG6QQ',
    };

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
getAnalytics(firebaseApp);

export default firebaseApp;
